import {z} from 'zod'
import {validateState} from '../ValidateState.ts'

export enum TileHexType {
    Desert = 0,
    Lumber = 1,
    Brick = 2,
    Wool = 3,
    Grain = 4,
    Ore = 5,
    Gold = 6,
    Fog = 7,
    Sea = 8,
}

export const tileHexStateSchema = z
    .object({
        x: z.number().int().readonly(),
        y: z.number().int().readonly(),
        type: z.enum(TileHexType),
        diceNumber: z.number().int().min(2).max(12),
    })
    .strict()

export type TileHexState = z.infer<typeof tileHexStateSchema>

export function validateTileHexState(data: unknown) {
    return validateState(tileHexStateSchema, data)
}

export const tileHexStatePartialSchema = tileHexStateSchema.partial().refine((obj) => Object.keys(obj).length > 0, {
    message: 'At least one property must be provided',
})

export type TileHexStatePartial = z.infer<typeof tileHexStatePartialSchema>

export function validateTileHexStatePartial(data: unknown) {
    return validateState(tileHexStatePartialSchema, data)
}
